import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {TemplateGroup} from "./template-group.model";

@Injectable({providedIn: 'root'})
export class TemplateGroupService {
    constructor(private http: HttpClient) {
    }

    clone(id: number, cloneProducts: boolean): Observable<TemplateGroup> {
        return this.http.get<TemplateGroup>(
            `${environment.rootUrl}/template-group/clone/${id}/${cloneProducts}`
        );
    }

    addToCategories(templateGroupIds: number[], categoryIds: number[]): Observable<boolean> {
        return this.http.post<boolean>(
            `${environment.rootUrl}/template-group/add-to-categories`,
            { entityIds: templateGroupIds, categoryIds }
        );
    }

    cloneToCategories(templateGroupIds: number[], categoryIds: number[], name?: string): Observable<boolean> {
        return this.http.post<boolean>(
            `${environment.rootUrl}/template-group/clone-to-categories`,
            { entityIds: templateGroupIds, categoryIds, name }
        );
    }

    moveToCategories(templateGroupIds: number[], categoryIds: number[]): Observable<boolean> {
        return this.http.post<boolean>(
            `${environment.rootUrl}/template-group/move-to-categories`,
            { entityIds: templateGroupIds, categoryIds }
        );
    }

    removeFromCategory(templateGroupId: number, categoryId: number): Observable<boolean> {
        return this.http.delete<boolean>(
            `${environment.rootUrl}/template-group/remove-from-category/${templateGroupId}/${categoryId}`
        );
    }
}
